<template>
  <tr>
    <td class="bg-red-lighter">
      <a
        :href="post._links.frontend.self"
        class="no-underline font-semibold"
        v-text="post.attributes.title"
      />
      <br>
      <span
        v-if="lastReply"
        class="text-sm text-grey-darker"
      >
        <span>
          Last reply from
          <span v-text="lastReply.creator.attributes.full_name" />
        </span> &nbsp;
        <span>&middot;</span> &nbsp;
        <span>
          {{ lastReply.attributes.created_at | calendarTime }}
        </span>
      </span>
      <span
        v-else
        class="text-sm text-grey-darker"
      >
        <span v-text="'No one has replied to this post yet.'" /> &nbsp;
      </span>
    </td>
    <td>
      <a
        class="btn btn--sm"
        :href="post.category._links.frontend.self"
        v-text="post.category.attributes.title"
      />
    </td>
    <td
      v-can="'manage-discussions'"
      :class="statusClass"
      v-text="post.attributes.status"
    />
    <td
      class="text-center text-grey-darker mr-4 font-semibold"
      v-text="post.meta.reply_count"
    />
  </tr>
</template>

<script type="text/babel">
export default {
  name: 'DiscussionListItem',
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  computed: {
    lastReply() {
      if (!_.get(this.post.lastReply, 'uuid', false)) {
        return false
      }

      return this.post.lastReply
    },
    statusClass() {
      switch (this.post.attributes.status) {
        case 'Declined':
          return 'text-red'
        case 'Approved':
          return 'text-green'
        case 'Pending':
          return 'text-blue'
        default:
          return 'text-grey-darker'
      }
    },
  },
}
</script>
